<template>
  <div>
    <div class="vue-nouislider" :id="sliderId">
      <transition name="fade">
        <div class="my-tip" v-show="tipShown" ref="tipRef">
          单个页面中，可呈现的视频时长不能超过20s
        </div>
      </transition>
        <!-- v-dragged="indicatorDrag" -->
      <div
        class="indicator"
        :style="{transform: `translate(${indicatorPosition.x}px, 0)`}"
        ref="indicator"
        v-show="indicatorInfo.show"
      >
        <div class="indicator__tooltip">
          {{indicatorInfo.time}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  var noUiSlider = require('./nouislider.js').default;
  import toAnalysisParams from '@/plugins/toAnalysisParams';

  export default {
    name: 'nouislider',
    props: {
      config: {
        type: Object,
        required: true,
      },
      values: {
        type: Array,
        required: false,
      },
      id: {
        type: String,
        required: false,
      },
    },
    data () {
      const vm = this;
      return {
        slider: null,
        tipShown: false,
        indicatorPosition: {
          x: 0,
          startX: 0,
          min: 0,
          max: 0,
          piece: 0, // 0.5秒的进度条长度
          info: {}
        },
        indicatorInfo: {
          show: false,
          time: '00:00'
        },
        oldValues: [...vm.values]
      }
    },
    watch: {
      'indicatorPosition.x': function (v) {
        this.assignVideoCurrentTime();
      },
      'indicatorInfo.show' (v) {
        let els = this.getHandlerTooltips()
        if (v) {
          $(els).hide();
        } else {
          $(els).show();
        }
      },
      // values (arr) {
      //   console.log({arr})
      // }
    },
    methods: {
      /**
       * Update a slider handle value
       * @param value
       * @param handle
       */
      updateValue: function (value, handle, nums) {
        this.videoJumpTime(value, this.oldValues);
        this.handlerTooltipOffset(handle, nums);
        this.oldValues = [...value];
        this.$set(this.values, handle, value[handle])
      },
      /**
       * Create a unique slider id
       * @returns {string}
       */
      uniqueId: function () {
        function s4 () {
          return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1)
        }
        return 'vue-nouislider-' + s4() + s4()
      },

      getHandlerDom () {
        return this.$el.querySelectorAll('.noUi-handle');
      },
      getHandlerTooltips () {
        return this.$el.querySelectorAll('.noUi-handle .noUi-tooltip');
      },
      toggleTip (flag) {
        if (!flag) {
          this.tipShown = false;
          return;
        }

        if (this.tipShown) {
          return;
        }

        let tip = this.$refs.tipRef;
        let handler = this.getHandlerDom()[1];
        let handlerRect = handler.getBoundingClientRect();
        let containerRect = this.$el.getBoundingClientRect();
        let dx = handlerRect.left - containerRect.left;
        tip.style.left = (dx + 24) + 'px';
        // let dy = handlerRect.top - containerRect.top;
        // tip.style.top = dy + 'px';

        this.tipShown = true;
      },

      initIndicator () {
        let sprite = this.$parent.$parent.sprite;
        let videoProps = sprite.video;
        let videoEl = this.$parent.$parent.$refs.videoEl;

        // let handlers = this.getHandlerDom();
        // let lower = handlers[0];
        // let lowerRect = lower.getBoundingClientRect();
        let containerRect = this.$el.getBoundingClientRect();
        let x = containerRect.width * videoProps.startTime / videoProps.duration;
        let piece = 0.5 / videoProps.duration * containerRect.width;
        videoEl.currentTime = videoProps.startTime;

        this.indicatorPosition = {
          ...this.indicatorPosition,
          x,
          min: 0,
          max: containerRect.width,
          piece
        };

        this.assignVideoCurrentTime();
      },
      /**
      indicatorDrag (info) {
        if (info.first) {
          this.indicatorDragStart(info);
          return
        }

        if (info.last) {
          this.indicatorDragEnd(info);
          return;
        }

        this.indicatorDragMove(info);
      },
      indicatorDragStart (info) {
        this.indicatorPosition.info = info;
        this.indicatorPosition.startX = this.indicatorPosition.x;
        this.$refs.indicator.style.cursor = 'ew-resize';
        this.$el.style.cursor = 'ew-resize';
      },
      indicatorDragMove (info) {
        let pos = this.indicatorPosition;
        let startInfo = this.indicatorPosition.info;
        let x = this.indicatorPosition.startX + info.clientX - startInfo.clientX;
        if (x >= pos.max) {
          x = pos.max;
        }
        if (x <= pos.min) {
          x = pos.min;
        }
        this.indicatorPosition = {
          ...this.indicatorPosition,
          x
        }
        this.$emit('dragMove')

        this.videoUpdateTime();
      },
      indicatorDragEnd (info) {
        // reset
        this.indicatorPosition = {
          ...this.indicatorPosition,
          startX: 0,
          info: {}
        }
        this.$refs.indicator.style.cursor = '';
        this.$el.style.cursor = '';

        let currX = this.indicatorPosition.x;
        let piece = this.indicatorPosition.piece;
        let remain = currX % piece;
        let xLower = Math.floor(currX / piece) * piece;
        let x = 0;
        if (remain < piece / 2) {
          x = xLower;
        } else {
          x = xLower + piece;
        }
        x = Math.min(x, this.indicatorPosition.max);
        this.indicatorPosition = {
          ...this.indicatorPosition,
          x
        }

        this.videoUpdateTime();
      },
      */
      videoUpdateTime () {
        let pos = this.indicatorPosition;
        let progress = pos.x / (pos.max - pos.min);
        let videoEl = this.$parent.$parent.$refs.videoEl;
        videoEl.currentTime = videoEl.duration * progress;
      },

      videoJumpTime (arr, old) {
        let videoEl = this.$parent.$parent.$refs.videoEl;
        if (arr[0] !== old[0] && arr[1] !== old[1]) {
          videoEl.currentTime = arr[0]
        }
        else if (arr[0] !== old[0] && arr[1] === old[1]) {
          videoEl.currentTime = arr[0]
        }
        else if (arr[0] === old[0] && arr[1] !== old[1]) {
          videoEl.currentTime = arr[1]
        }
      },

      getVideoCurrentTime () {
        let videoEl = this.$parent.$parent.$refs.videoEl;
        return {
          num: videoEl.currentTime,
          format: this.$util.formatDur2(videoEl.currentTime)
        }
      },

      assignVideoCurrentTime () {
        let obj = this.getVideoCurrentTime();
        this.indicatorInfo = {
          ...this.indicatorInfo,
          time: obj.format
        }
      },

      videoPreview () {
        const vm = this;
        let videoEl = this.$parent.$parent.$refs.videoEl;
        let sprite = this.$parent.$parent.sprite;
        let videoProps = sprite.video;
        let previewStartTime = vm.values[0] - 0;
        let previewDuration = vm.values[1] - vm.values[0];
        videoEl.currentTime = previewStartTime;
        videoEl.volume = videoProps.volume > 1 ? videoProps.volume / 100 : videoProps.volume;
        vm.indicatorInfo.show = true;
        videoEl.play();
        videoEl.h = videoEl.h || h;
        videoEl.removeEventListener('timeupdate', videoEl.h);
        videoEl.addEventListener('timeupdate', videoEl.h);
        function h() {
          let progress = videoEl.currentTime / videoEl.duration;
          let x = progress * (vm.indicatorPosition.max - vm.indicatorPosition.min);
          let previewStartTime = vm.values[0] - 0;
          let previewDuration = vm.values[1] - vm.values[0];
          vm.indicatorPosition = {
            ...vm.indicatorPosition,
            x
          }
          if (previewStartTime + previewDuration - videoEl.currentTime <= 0.1) {
            videoEl.pause();
            vm.indicatorInfo.show = false;
            videoEl.currentTime = previewStartTime + previewDuration;
            videoEl.removeEventListener('timeupdate', videoEl.h);
          }
        }
      },

      videoPreviewStop () {
        const vm = this;
        let videoEl = this.$parent.$parent.$refs.videoEl;
        if (videoEl.paused) {
          return;
        }
        let progress = videoEl.currentTime / videoEl.duration;
        let x = progress * (vm.indicatorPosition.max - vm.indicatorPosition.min);
        this.assignIndicatorPosition({x});
        videoEl.pause();
        vm.indicatorInfo.show = false;
        videoEl.h && videoEl.removeEventListener('timeupdate', videoEl.h);
      },

      assignIndicatorPosition (obj = {}) {
        const vm = this;
        vm.indicatorPosition = {
          ...vm.indicatorPosition,
          ...obj
        }
      },

      handlerTooltipOffset (handlerIndex = 0, values) {
        let els = this.getHandlerTooltips();
        let $els = $(els);
        let w = els[0].offsetWidth;
        let piece = this.indicatorPosition.piece;
        let delta = values[1] - values[0];
        let distance = delta / 0.5 * piece;
        // $els.hide()
        if (distance < w) {
          $els.addClass('offset');
        } else {
          $els.removeClass('offset');
        }
        // $els.show();
      }
    },
    computed: {
      /**
       * Set the slider ID with prop value or random ID
       * @returns {string}
       */
      sliderId () {
        if (this.id === undefined) {
          return this.uniqueId()
        }
        return this.id
      },
      valuesDelta () {
        return this.values[1] = this.values[0];
      }
    },
    mounted () {
      this.slider = document.getElementById(this.sliderId)
      this.config.start = this.values
        && this.values.length && this.values || this.config.start;
      noUiSlider.create(this.slider, this.config);

      this.$nextTick(() => {
        const _f = function (selector, vm, fn) {
          vm.slider.querySelector(selector)
          .addEventListener('mousedown', () => {
            window.document.documentElement.addEventListener('mouseup', function h () {
              fn && fn()
              this.removeEventListener('mouseup', h);
            })
          })
        }

        _f('.noUi-handle.noUi-handle-lower', this, () => {
          this.$analysis(toAnalysisParams('video_clipping_panel,click_left_cutter,拖拽左裁剪框'));
        });
        _f('.noUi-handle.noUi-handle-upper', this, () => {
          this.$analysis(toAnalysisParams('video_clipping_panel,click_right_cutter,拖拽右裁剪框'));
        });
        _f('.noUi-connect.noUi-draggable', this, () => {
          this.$analysis(toAnalysisParams('video_clipping_panel,click_middle_cutter,拖拽中间裁剪区'));
        })
      })

      this.slider.noUiSlider.on('update', this.updateValue)
      // Listen for Event on parent component if values are changed
      this.$parent.$on('updateValue', (value) => {
        this.slider.noUiSlider.set(value)
      })
      // Fire Event if new value is set with the slider
      this.slider.noUiSlider.on('change', (newValues) => {
        this.$parent.$emit('newValueSet', newValues)
      })
      this.slider.noUiSlider.on('start', (...args) => {
        this.$parent.$off('updateValue')
        this.videoPreviewStop();
        this.oldValues = [...this.values];
      })
      this.slider.noUiSlider.on('setHandle', (...args) => {
        let nums = args[2];
        let handlerIndex = args[1];
        if (handlerIndex !== this.draggingHandlerIndex) {
          this.toggleTip(false);
          this.draggingHandlerIndex = handlerIndex;
          return;
        }

        if (
          nums[1] - nums[0] >= this.config.limit
        ) {
          this.toggleTip(true);
          setTimeout(() => {
            this.toggleTip(false);
          }, 4000)
        } else {
          this.toggleTip(false);
        }

        this.draggingHandlerIndex = handlerIndex;
      })
      this.slider.noUiSlider.on('end', (...args) => {
        let nums = args[2];
        let handlerIndex = args[1];
        this.$parent.$on('updateValue', (value) => {
          this.slider.noUiSlider.set(value)
        })
        // this.videoJumpTime(this.values, this.oldValues);
        this.handlerTooltipOffset(handlerIndex, nums);
      })

      this.initIndicator();
      this.handlerTooltipOffset(0, this.values);
    },
  }
</script>

<style lang="scss">
  @import '../../style/_triangle.scss';
  @import './nouislider';

  .vue-nouislider {
    position: relative;
    width: 738px;
    height: 40px;
    background-color: #47474a;

    & > .my-tip {
      position: absolute;
      z-index: 2;
      top: calc(50% - 20px);
      height: 40px;
      width: 150px;
      background-color: rgba(#000, .5);
      border-radius: 4px;
      padding: 5px;

      &:before {
        content: ' ';
        position: absolute;
        top: 50%;
        right: 100%;
        transform: translatey(-50%);
        @include triangle(left, 12px, 12px, rgba(#000, .5));
      }
    }

    & > .indicator {
      position: absolute;
      z-index: 2;
      top: -3px;
      left: 0;
      width: 2px;
      height: 46px;
      background-color: #fff;
      cursor: ew-resize;

      & > .indicator__tooltip {
        position: absolute;
        bottom: 110%;
        left: 50%;
        transform: translatex(-50%);
        text-align: center;
        line-height: 20px;
        padding: 0;
        width: 90px;
        height: 20px;
        box-sizing: border-box;
        border-radius: 20px;
        background-color: #fff;
        color: #000;

      }

      &::before {
        content: ' ';
        position: absolute;
        bottom: 98%;
        left: 50%;
        transform: translatex(-50%);
        @include triangle(bottom, 8px, 8px, #fff);
      }
    }
  }

  .noUi-horizontal .noUi-handle {
    top: 7px;
    width: 10px;
    height: 26px;
    background-color: #87b4ff;
    border: none;
    box-shadow: none;
    border-radius: 4px;
    outline: none;
    cursor: ew-resize;

    &::before {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 4px;
      height: 8px;
      background-color: transparent;
      // background-image: url();
    }

    &::after {
      display: none;
    }

    &.noUi-handle-lower {
      &::before {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAYAAADeM14FAAAATElEQVQImU3MwQ2DQBQD0fe3AsqgW7qJFHFNAYAUpQVEEXEuuyJzs8a2JJLAhKV6UFUn3sPuWId84TGmDYWvQa8deCbxf3pha25mfH5hlCiU4rkIlgAAAABJRU5ErkJggg==);
      }

      .noUi-tooltip {
        // transform: none;
        // left: auto;
        bottom: 150%;
        // right: 0;

        &.offset {
          // transform: translatex(-80px);
          // margin-left: -80px;
          transform: none;
          left: -85px;
          border-bottom-right-radius: 0;

          &:before {
            left: 100%;
            transform: translateX(-8px);
            @include triangle(topright, 8px, 8px, #fff);
          }
        }
      }
    }
    &.noUi-handle-upper {
      &::before {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAYAAADeM14FAAAARUlEQVQImU3NwQ1AUBRE0fMUYWtJrWqRoB2/Cw2MjR/ucpKTgRVjEkkMWND0ksCJK4l6B1W1YRp8BdXJ3gkcuP8vDXN3D9GpJBZKqZFhAAAAAElFTkSuQmCC);
      }

      .noUi-tooltip {
        // transform: none;
        // left: 0;
        bottom: 150%;
        // right: auto;

        &.offset {
          // transform: translatex(0);
          // margin-left: 80px;
          transform: none;
          border-bottom-left-radius: 0;

          &:before {
            left: 0;
            transform: translateX(0);
            @include triangle(topleft, 8px, 8px, #fff);
          }
        }
      }
    }

    & .noUi-tooltip {
      border-style: none;
      border-width: 0;
      transition-duration: .1s;
      &:before {
        content: ' ';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        @include triangle(bottom, 8px, 8px, #fff);
      }
    }
  }

  html:not([dir="rtl"]) .noUi-horizontal .noUi-handle {
    right: -5px;
    left: auto;
  }

  .noUi-tooltip {
    text-align: center;
    line-height: 20px;
    padding: 0;
    width: 90px;
    height: 20px;
    box-sizing: border-box;
    border-radius: 20px;
  }

  .noUi-horizontal .noUi-tooltip {
    bottom: 150%;
  }

  .noUi-draggable {
    cursor: grab;
    border: solid 1px #87b4ff;
    background-color: #444976;
	  border-radius: 4px;
  }

  .noUi-target {
    border: none;
    box-shadow: none;
  }

  .fade-enter-active/*, .fade-leave-active*/ {
    transition: opacity .6s;
  }
  .fade-leave-active {
    transition: opacity .8s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/plugins/pluginSlider/nouislider.vue